<div [formGroup]="inputForm">
    <nz-form-item style="max-width: 100%; margin-right: 0;flex-wrap: nowrap;">
        <nz-form-label
            [style]="field.type === 'boolean' ? 'order: 1;' : 'order: 0;'"
            *ngIf="field.label"
            [nzNoColon]="field.type === 'boolean'"
            [nzFor]="field.id"
            [nzRequired]="field.required"
            style="white-space: normal;flex: none !important;"
            >{{ field.label }}</nz-form-label
        >

        <nz-form-control
            [style]="field.type === 'boolean' ? 'order: 0;' : 'order: 1;'"
            nzErrorTip="Error"
        >
            <label
                *ngIf="field.type === 'boolean'; else inputTmp"
                nz-checkbox
                [formControlName]="field.id"
            ></label>
            <ng-template #inputTmp>
                <input
                    *ngIf="field.type === 'string' || field.type === 'number'"
                    nz-input
                    [disabled]="true"
                    [type]="field.type"
                    [formControlName]="field.id"
                    [id]="field.id"
                />
            </ng-template>
        </nz-form-control>
    </nz-form-item>
</div>
